import React from "react";
import styled from "styled-components";
import { TradeIn } from "Types/TradeIn";

const Root = styled("div")`
    margin: 12px 0 0;
`;

const Input = styled("input")`
    font-size: 16px;
    height: 40px;
    padding-left: 10px;
    width: 100%;

    &:disabled {
        cursor: not-allowed;
    }
`;

interface VehicleFoundProps {
    tradePending: Partial<TradeIn>;
}

class VehicleFound extends React.Component<VehicleFoundProps> {
    public render() {
        const { tradePending } = this.props;
        const inputValue = tradePending.ymmt
            ? tradePending.ymmt
            : `${tradePending.year} ${tradePending.make} ${tradePending.model} ${tradePending.trim}`;

        return (
            <Root>
                <Input disabled placeholder={inputValue} value={inputValue} />
            </Root>
        );
    }
}

export default VehicleFound;
